export const GtmPushDataLayer = (payload) => {
  try {
    window.dataLayer.push({
      ...payload,
    })
  } catch (error) {
    return error
  }
}
